export enum PendingSignatureTooltip {
    LIST_OWNER = "Pending signature from Internal",
    BROKER = "Pending signature from Broker",
    LIST_OWNER_AND_BROKER = "Pending signatures from Internal and Broker",
}

export function getPendingSignatureTooltip(pendingSignatures: string[]): string | undefined {
    if (!pendingSignatures || pendingSignatures.length === 0) return undefined;
    if (pendingSignatures.length === 2 && pendingSignatures.includes("list_owner") && pendingSignatures.includes("broker")) {
        return PendingSignatureTooltip.LIST_OWNER_AND_BROKER;
    }
    if (pendingSignatures.length === 1) {
        if (pendingSignatures[0] === "list_owner") return PendingSignatureTooltip.LIST_OWNER;
        if (pendingSignatures[0] === "broker") return PendingSignatureTooltip.BROKER;
    }
    return undefined;
}
